<h1 i18n="@@upp.dynamicExclusions.display.title">Display Dynamic Exclusion Rule</h1>

<ama-upp-notification
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<ama-ng-upp-fares-details-v2
  [fareDetailsForm]="fareForm"
  [fareDetails]="fareRule"
  [readonly]="readonly"
  [parent]="uppComponent"
>
</ama-ng-upp-fares-details-v2>

<div class="d-flex justify-content-end">
  <button
    i18n="@@upp.global.button.modify"
    type="button"
    [disabled]="!modifyButtonEnabled()"
    class="btn btn-primary mb-2 mb-md-0 me-2 actionButton"
    (click)="modifyFare()"
  >
    Modify
  </button>
</div>
